import { createSlice } from '@reduxjs/toolkit';
import { type IAccount } from '../../types/IAccountsResponse';
import { getAdminsListThunk } from './managersListThunks';

export interface IManagersListState {
  admins: IAccount[];
  isLoading: boolean;
  error: string | null;
  isLoaded: boolean;
}

const initialState: IManagersListState = {
  admins: [],
  isLoading: false,
  error: null,
  isLoaded: false
};

const managersListSlice = createSlice({
  name: 'managersList',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetState: (state) => {
      state.admins = [];
      state.isLoading = false;
      state.error = null;
      state.isLoaded = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdminsListThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAdminsListThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.admins = action.payload.items;
        state.error = null;
        state.isLoaded = true;
      })
      .addCase(getAdminsListThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload === undefined
            ? null
            : (action.payload?.message ??
              'Произошла ошибка при загрузке списка админов');
      });
  }
});

export const { clearError, resetState } = managersListSlice.actions;
export { getAdminsListThunk };
export default managersListSlice.reducer;
